import type {CatalogueTreeResponseBody} from '@dms/api/new-vehicle';

/** Make, model and model year names live only in the catalogue tree, not on the configuration. */
export const findCatalogueModelYear = (
  tree: CatalogueTreeResponseBody | undefined,
  modelYearId: string
) =>
  tree?.makes
    .flatMap((make) =>
      make.models.flatMap((model) =>
        model.modelYears
          .filter(({id}) => id === modelYearId)
          .map((modelYear) => ({make, model, modelYear}))
      )
    )
    .at(0);
